import { DialogLogoClientComponent } from './../../shared/components/dialog-logo-client/dialog-logo-client.component';
import { AuthService } from './../../shared/services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { ClientsService } from '@services/clients.service';
import { Client } from '@classes/client';
import { MatPaginator } from '@angular/material/paginator';
import { RoleName } from '@enums/role-name.enum';
import { MatDialog } from '@angular/material/dialog';
import { DialogKooveaManagementComponent } from '@components/dialog-koovea-management/dialog-koovea-management.component';

const reader = new FileReader();

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})
export class ClientsComponent extends DatatableBaseComponent implements OnInit {
  clients: Client[];

  dataSource: MatTableDataSource<Client>;
  isAdminClient: boolean;
  isAdmin: boolean;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private clientsSrv: ClientsService,
    private authSrv: AuthService,
    public dialog: MatDialog
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getRouteData();

    this.isAdminClient =
      this.authSrv.getUser().role.name === RoleName.admin_client || this.authSrv.getUser().role.name === RoleName.admin || this.authSrv.getUser().role.name === RoleName.admin_subcontractor;

    this.isAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev || this.authSrv.getUser().role.name === RoleName.super_admin || this.authSrv.getUser().role.name === RoleName.admin || this.authSrv.getUser().role.name === RoleName.admin_subcontractor;

    this.initSubscriptions();

    this._initColumnsParams();

    this.readColumnsParamsFromLocalStorage();
    this.generateDisplayedColumns();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.clients);
    this.dataSource.sort = this.sort;
  }

  private _initColumnsParams() {
    this.localStorageColumnsParamsName = 'ColumnsParamsClients';

    this.columnsParams = [
      {
        name: 'name',
        title: 'repository.clients.list.name',
        editable: true,
        visible: true,
      },
      {
        name: 'email',
        title: 'repository.clients.list.email',
        editable: true,
        visible: true,
      },
      // {
      //   name: 'features',
      //   title: 'repository.clients.list.features',
      //   editable: true,
      //   visible: true,
      // },
      {
        name: 'phone',
        title: 'repository.clients.list.phone',
        editable: true,
        visible: true,
      },
      {
        name: 'fax',
        title: 'repository.clients.list.fax',
        editable: true,
        visible: true,
      },
      {
        name: 'contact',
        title: 'repository.clients.list.contact',
        editable: true,
        visible: true,
      },
      {
        name: 'webSite',
        title: 'repository.clients.list.webSite',
        editable: true,
        visible: true,
      },
      {
        name: 'street',
        title: 'repository.clients.list.street',
        editable: true,
        visible: true,
      },
      {
        name: 'streetNumber',
        title: 'repository.clients.list.streetNumber',
        editable: true,
        visible: true,
      },
      {
        name: 'locality',
        title: 'repository.clients.list.locality',
        editable: false,
        visible: true,
      },
      {
        name: 'postalCode',
        title: 'repository.clients.list.postalCode',
        editable: true,
        visible: true,
      },
      {
        name: 'siret',
        title: 'repository.clients.list.siret',
        editable: true,
        visible: true,
      },
      {
        name: 'ape',
        title: 'repository.clients.list.ape',
        editable: true,
        visible: true,
      },
      {
        name: 'tva',
        title: 'repository.clients.list.tva',
        editable: true,
        visible: true,
      },
      {
        name: 'actions',
        title: 'repository.clients.list.actions',
        editable: false,
        visible: true,
      },
    ];
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { clients: Client[] }) => {
        this.clients = data.clients;
        this.initTable();
      });
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.clientsSrv.clientsListChanged
        .subscribe(clients => {
          this.dataSource.data = clients || [];
          this.dataSource.sort = this.sort;
          this.onEditFinished();
        })
    );
  }

  delete(idClient: string) {
    const confirmation = confirm('Êtes-vous certain de vouloir supprimer cette agence ?');

    if (confirmation) {
      this.clientsSrv.delete(idClient).subscribe(() => {
        this.uiSrv.showSnackbar('repository.clients.deleted', true);
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialog(client: Client): void {
    let urlImg = '';
    const clientPromise = new Promise((resolve, reject) => {
      if (client.hasLogo) {
        this.clientsSrv.getLogo(client.id).subscribe(img => {
          reader.readAsDataURL(img);
          reader.onload = (res) => {
            urlImg = res.target.result.toString();
            resolve(true);
          };
        });
      } else {
        resolve(true);
      }
    });

    clientPromise.then(() => {
      const dialogRef = this.dialog.open(DialogLogoClientComponent, {
        width: '350px',
        data: { client: client, urlImg: urlImg }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
    });
  }

  openKooveaDialog(client: Client): void {
    const dialogRef = this.dialog.open(DialogKooveaManagementComponent, {
      width: '400px',
      data: { clientId: client.id }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  downloadLogo(id: string) {
    this.clientsSrv.downloadLogo(id).subscribe();
  }

}
